export class AccountGopInfo {
  supplierId: number;
  accompanyingLetter: string;
  commitmentType: string;
  commitmentTypeCode: string;
  gopLanguage: string;
  gopMethod: string;
  gopTemplate: string;

  constructor(init?: Partial<AccountGopInfo>) {
    Object.assign(this, init);
  }
}
